require('./angular');
module.exports = angular;



//////////////////
// WEBPACK FOOTER
// ./~/angular/index.js
// module id = 126
// module chunks = 1